module.exports = __webpack_public_path__ + "static/feature-actions-ca8ad7024204572744ceb21eb081617a.png";